module.exports = __webpack_public_path__ + "img/homeVideoBg.10f615cb.png";